unit dashboard.loads.notinvoiced;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, Vcl.Controls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, Vcl.StdCtrls, VCL.TMSFNCButton,
  System.Generics.Collections;

type
  Tfrmdashboardloadsnotinvoiced = class(TForm)
    wpTop: TPanel;
    WebScrollBox1: TScrollBox;
    wpLeft: TPanel;
    gClient: TTMSFNCDataGrid;
    wcClient: TXDataWebClient;
    wdsClient: TXDataWebDataSet;
    dsClient: TDataSource;
    wdsClientDebName: TStringField;
    wdsClientContractName: TStringField;
    wdsClientDebCode: TStringField;
    wdsClientContractNo: TIntegerField;
    wdsClientTotalLoads: TIntegerField;
    wdsClientLess10Days: TIntegerField;
    wdsClientOver10Days: TIntegerField;
    wdsClientOver20Days: TIntegerField;
    gdaClient: TTMSFNCDataGridDatabaseAdapter;
    TMSFNCButton1: TTMSFNCButton;
    wpRight: TPanel;
    gDetail: TTMSFNCDataGrid;
    gdaDetail: TTMSFNCDataGridDatabaseAdapter;
    wcDetail: TXDataWebClient;
    wdsDetail: TXDataWebDataSet;
    dsDetail: TDataSource;
    wdsDetailLoadConNo: TIntegerField;
    wdsDetailRegNo: TStringField;
    wdsDetailController: TStringField;
    wdsDetailLoadedDate: TDateTimeField;
    wdsDetailReceivedDate: TDateTimeField;
    wdsDetailScannedDate: TDateTimeField;
    gTracking: TTMSFNCDataGrid;
    gdaTracking: TTMSFNCDataGridDatabaseAdapter;
    wcTracking: TXDataWebClient;
    wdsTracking: TXDataWebDataSet;
    dsTracking: TDataSource;
    wdsTrackingAutoNo: TIntegerField;
    wdsTrackingLoadConNo: TIntegerField;
    wdsTrackingForUserCode: TStringField;
    wdsTrackingScanDateTime: TDateTimeField;
    wdsTrackingScanType: TStringField;
    wdsTrackingForUserName: TStringField;
    wdsTrackingScanUser: TStringField;
    wdsTrackingScanName: TStringField;
    procedure TMSFNCButton1Click(Sender: TObject);
    procedure wdsClientAfterOpen(DataSet: TDataSet);
    procedure gClientAfterDrawCell(Sender: TObject; AGraphics: TTMSFNCGraphics;
      ACell: TTMSFNCDataGridCell);
    procedure gClientCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure gDetailGetCellFormatting(Sender: TObject;
      ACell: TTMSFNCDataGridCellCoord; AData: TTMSFNCDataGridCellValue;
      var AFormatting: TTMSFNCDataGridDataFormatting;
      var AConvertSettings: TFormatSettings; var ACanFormat: Boolean);
    procedure gDetailAfterDrawCell(Sender: TObject; AGraphics: TTMSFNCGraphics;
      ACell: TTMSFNCDataGridCell);
    procedure gDetailCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure gTrackingGetCellFormatting(Sender: TObject;
      ACell: TTMSFNCDataGridCellCoord; AData: TTMSFNCDataGridCellValue;
      var AFormatting: TTMSFNCDataGridDataFormatting;
      var AConvertSettings: TFormatSettings; var ACanFormat: Boolean);
    procedure gTrackingAfterDrawCell(Sender: TObject;
      AGraphics: TTMSFNCGraphics; ACell: TTMSFNCDataGridCell);
  private
    { Private declarations }
    procedure GroupDataClient;
    procedure DoGroupSums;
    procedure LoadDetailData;
    procedure LoadTrackingData;
  public
    { Public declarations }
    iMonth,
    iYear,
    iCompany : Integer;
    procedure LoadDataClient;
  protected procedure LoadDFMValues; override; end;

var
  frmdashboardloadsnotinvoiced: Tfrmdashboardloadsnotinvoiced;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  share.common,
  share.classes;

procedure Tfrmdashboardloadsnotinvoiced.DoGroupSums;
  var
    c : Integer;
begin
  c := gClient.ColumnIndexByHeader('Less 10 Days');
  gClient.ColumnCalculations[c, ''] := [CreateGroupColumnCalculation(gcmSum,
  procedure(AColumn : Integer; ALevel : Integer; var AOptions : TTMSFNCDataGridDataColumnCalculationOptions)
    begin
      Case ALevel of
        0 : AOptions.CalculationFormat := '%g';
      End;
    end)];

  c := gClient.ColumnIndexByHeader('Over 10 Days');
  gClient.ColumnCalculations[c, ''] := [CreateGroupColumnCalculation(gcmSum,
  procedure(AColumn : Integer; ALevel : Integer; var AOptions : TTMSFNCDataGridDataColumnCalculationOptions)
    begin
      Case ALevel of
        0 : AOptions.CalculationFormat := '%g';
      End;
    end)];

  c := gClient.ColumnIndexByHeader('Over 20 Days');
  gClient.ColumnCalculations[c, ''] := [CreateGroupColumnCalculation(gcmSum,
  procedure(AColumn : Integer; ALevel : Integer; var AOptions : TTMSFNCDataGridDataColumnCalculationOptions)
    begin
      Case ALevel of
        0 : AOptions.CalculationFormat := '%g';
      End;
    end)];

  c := gClient.ColumnIndexByHeader('Total Loads');
  gClient.ColumnCalculations[c, ''] := [CreateGroupColumnCalculation(gcmSum,
  procedure(AColumn : Integer; ALevel : Integer; var AOptions : TTMSFNCDataGridDataColumnCalculationOptions)
    begin
      Case ALevel of
        0 : AOptions.CalculationFormat := '%g';
      End;
    end)];
end;

procedure Tfrmdashboardloadsnotinvoiced.gClientAfterDrawCell(Sender: TObject;
  AGraphics: TTMSFNCGraphics; ACell: TTMSFNCDataGridCell);
  var
    r : TRectF;
    iValue : Integer;
begin
  If (ACell.Column = 3) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      iValue := gClient.Ints[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 60 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      If iValue > 0 then
        begin
          AGraphics.Fill.Color := gcYellow;
          AGraphics.Font.Color := gcBlack;
        end;
      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      AGraphics.DrawText(r, IntToStr(iValue), False, gtaCenter, gtaCenter);
    end;

  If (ACell.Column = 4) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      iValue := gClient.Ints[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 60 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      If iValue > 0 then
        begin
          AGraphics.Fill.Color := gcRed;
          AGraphics.Font.Color := gcWhite;
        end;
      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      AGraphics.DrawText(r, IntToStr(iValue), False, gtaCenter, gtaCenter);
    end;
end;

procedure Tfrmdashboardloadsnotinvoiced.gClientCellClick(Sender: TObject;
  AColumn, ARow: Integer);
begin
  LoadDetailData;
end;

procedure Tfrmdashboardloadsnotinvoiced.gDetailAfterDrawCell(Sender: TObject;
  AGraphics: TTMSFNCGraphics; ACell: TTMSFNCDataGridCell);
  var
    r : TRectF;
    dtValue : TDate;
begin
  If (ACell.Column = 1) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      dtValue := gDetail.Floats[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 95 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      If (dtValue <= Date - 5) and (dtValue > Date - 10) then
        begin
          AGraphics.Fill.Color := gcYellow;
          AGraphics.Font.Color := gcBlack;
        end
      else
        begin
          If (dtValue <= Date - 10) then
            begin
              AGraphics.Fill.Color := gcRed;
              AGraphics.Font.Color := gcWhite;
            end
          else
            begin
              AGraphics.Fill.Color := gcGreen;
              AGraphics.Font.Color := gcWhite;
            end;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      AGraphics.DrawText(r, FormatDateTime('dd/MM/yyyy', dtValue), False, gtaCenter, gtaCenter);
    end;

  If (ACell.Column = 2) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      dtValue := gDetail.Floats[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 95 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      If (dtValue <= Date - 5) and (dtValue > Date - 10) then
        begin
          AGraphics.Fill.Color := gcYellow;
          AGraphics.Font.Color := gcBlack;
        end
      else
        begin
          If (dtValue <= Date - 10) then
            begin
              AGraphics.Fill.Color := gcRed;
              AGraphics.Font.Color := gcWhite;
            end
          else
            begin
              AGraphics.Fill.Color := gcGreen;
              AGraphics.Font.Color := gcWhite;
            end;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      AGraphics.DrawText(r, FormatDateTime('dd/MM/yyyy', dtValue), False, gtaCenter, gtaCenter);
    end;

  If (ACell.Column = 3) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      dtValue := gDetail.Floats[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 95 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      If (dtValue <= Date - 5) and (dtValue > Date - 10) then
        begin
          AGraphics.Fill.Color := gcYellow;
          AGraphics.Font.Color := gcBlack;
        end
      else
        begin
          If (dtValue <= Date - 10) then
            begin
              AGraphics.Fill.Color := gcRed;
              AGraphics.Font.Color := gcWhite;
            end
          else
            begin
              AGraphics.Fill.Color := gcGreen;
              AGraphics.Font.Color := gcWhite;
            end;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      AGraphics.DrawText(r, FormatDateTime('dd/MM/yyyy', dtValue), False, gtaCenter, gtaCenter);
    end;
end;

procedure Tfrmdashboardloadsnotinvoiced.gDetailCellClick(Sender: TObject;
  AColumn, ARow: Integer);
begin
  LoadTrackingData;
end;

procedure Tfrmdashboardloadsnotinvoiced.gDetailGetCellFormatting(
  Sender: TObject; ACell: TTMSFNCDataGridCellCoord;
  AData: TTMSFNCDataGridCellValue;
  var AFormatting: TTMSFNCDataGridDataFormatting;
  var AConvertSettings: TFormatSettings; var ACanFormat: Boolean);
begin
  if ACell.Row = 0 then
    Exit;

  ACanFormat := True;

  If (ACell.Column = 1) or
     (ACell.Column = 2) or
     (ACell.Column = 3) then
    begin
      AFormatting.Format := 'dd/mm/yyyy';  // Custom date format
      AFormatting.&Type := gdftDate;  // Set the formatting type to Date
      AConvertSettings.ShortDateFormat := 'dd/mm/yyyy';  // Ensure date is displayed as yyyy/mm/dd
      AConvertSettings.DateSeparator := '/';
    end;
end;

procedure Tfrmdashboardloadsnotinvoiced.GroupDataClient;
  var
    l : TList<Integer>;
    c : TTMSFNCDataGridDataGetCustomGroupCallBack;
begin
  l := TList<Integer>.Create;

  l.Add(0);

  gClient.Group(CreateGroupInfo(l.ToArray), c);

  l.free;

  gClient.CollapseAllNodes;

  DoGroupSums;
end;

procedure Tfrmdashboardloadsnotinvoiced.gTrackingAfterDrawCell(Sender: TObject;
  AGraphics: TTMSFNCGraphics; ACell: TTMSFNCDataGridCell);
  var
    r : TRectF;
    dtValue : TDate;
begin
  If (ACell.Column = 0) and (ACell.Row > 0) then
    begin
      AGraphics.Stroke.Color := gcBlack;

      dtValue := gTracking.Floats[ACell.Column,ACell.Row];

      r := ACell.Rect;
      r.Right := r.Left + 95 * ACell.Scale;
      InflateRectEx(r,-4 * ACell.Scale, -4 * ACell.Scale);

      If (dtValue <= Date - 5) and (dtValue > Date - 10) then
        begin
          AGraphics.Fill.Color := gcYellow;
          AGraphics.Font.Color := gcBlack;
        end
      else
        begin
          If (dtValue <= Date - 10) then
            begin
              AGraphics.Fill.Color := gcRed;
              AGraphics.Font.Color := gcWhite;
            end
          else
            begin
              AGraphics.Fill.Color := gcGreen;
              AGraphics.Font.Color := gcWhite;
            end;
        end;

      AGraphics.DrawRoundRectangle(r, 5 * ACell.Scale);
      AGraphics.DrawText(r, FormatDateTime('dd/MM/yyyy', dtValue), False, gtaCenter, gtaCenter);
    end;
end;

procedure Tfrmdashboardloadsnotinvoiced.gTrackingGetCellFormatting(
  Sender: TObject; ACell: TTMSFNCDataGridCellCoord;
  AData: TTMSFNCDataGridCellValue;
  var AFormatting: TTMSFNCDataGridDataFormatting;
  var AConvertSettings: TFormatSettings; var ACanFormat: Boolean);
begin
  if ACell.Row = 0 then
    Exit;

  ACanFormat := True;

  If (ACell.Column = 0) then
    begin
      AFormatting.Format := 'dd/mm/yyyy';  // Custom date format
      AFormatting.&Type := gdftDate;  // Set the formatting type to Date
      AConvertSettings.ShortDateFormat := 'dd/mm/yyyy';  // Ensure date is displayed as yyyy/mm/dd
      AConvertSettings.DateSeparator := '/';
    end;
end;

procedure Tfrmdashboardloadsnotinvoiced.LoadDataClient;

  procedure OnError(Error: TXDataClientError);
  begin
    LoadDataClient;
  end;

  procedure OnResult (Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadDataClient;
      end
    else
      begin
        wdsClient.Close;
        wdsClient.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsClient.Open;
      end;
  end;
begin
  wcClient.RawInvoke('IdashboardService.GetLoadsNotInvDetails', [iMonth,iYear,iCompany], @OnResult, @OnError);
end;

procedure Tfrmdashboardloadsnotinvoiced.LoadDetailData;
  procedure OnError(Error: TXDataClientError);
  begin
    LoadDetailData;
  end;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadDetailData;
      end
    else
      begin
        wdsTracking.Close;
        wdsDetail.Close;
        wdsDetail.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsDetail.Open;
      end;
  end;

begin
  wcDetail.RawInvoke('IdashboardService.GetLoadsNotInvDetailsTracking', [iMonth, iYear, iCompany, wdsClient.FieldByName('contractno').asInteger,wdsClient.FieldByName('debcode').asString], @OnResult, @OnError);
end;

procedure Tfrmdashboardloadsnotinvoiced.LoadTrackingData;
  procedure OnError(Error: TXDataClientError);
  begin
    LoadTrackingData;
  end;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
      begin
        LoadTrackingData;
      end
    else
      begin
        wdsTracking.Close;
        wdsTracking.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
        wdsTracking.Open;
      end;
  end;

begin
  wcTracking.RawInvoke('IdashboardService.GetLoadsNotInvDetailsTrackingDetails', [wdsDetail.FieldByName('LoadConNo').asInteger], @OnResult, @OnError);
end;

procedure Tfrmdashboardloadsnotinvoiced.TMSFNCButton1Click(Sender: TObject);
begin
  Close;
end;

procedure Tfrmdashboardloadsnotinvoiced.wdsClientAfterOpen(DataSet: TDataSet);
begin
  GroupDataClient;
end;

procedure Tfrmdashboardloadsnotinvoiced.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wpTop := TPanel.Create(Self);
  TMSFNCButton1 := TTMSFNCButton.Create(Self);
  WebScrollBox1 := TScrollBox.Create(Self);
  wpLeft := TPanel.Create(Self);
  gClient := TTMSFNCDataGrid.Create(Self);
  gdaClient := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wpRight := TPanel.Create(Self);
  gDetail := TTMSFNCDataGrid.Create(Self);
  gdaDetail := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  gTracking := TTMSFNCDataGrid.Create(Self);
  gdaTracking := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcClient := TXDataWebClient.Create(Self);
  wdsClient := TXDataWebDataSet.Create(Self);
  wdsClientDebName := TStringField.Create(Self);
  wdsClientContractName := TStringField.Create(Self);
  wdsClientDebCode := TStringField.Create(Self);
  wdsClientContractNo := TIntegerField.Create(Self);
  wdsClientTotalLoads := TIntegerField.Create(Self);
  wdsClientLess10Days := TIntegerField.Create(Self);
  wdsClientOver10Days := TIntegerField.Create(Self);
  wdsClientOver20Days := TIntegerField.Create(Self);
  dsClient := TDataSource.Create(Self);
  wcDetail := TXDataWebClient.Create(Self);
  wdsDetail := TXDataWebDataSet.Create(Self);
  wdsDetailLoadConNo := TIntegerField.Create(Self);
  wdsDetailRegNo := TStringField.Create(Self);
  wdsDetailController := TStringField.Create(Self);
  wdsDetailLoadedDate := TDateTimeField.Create(Self);
  wdsDetailReceivedDate := TDateTimeField.Create(Self);
  wdsDetailScannedDate := TDateTimeField.Create(Self);
  dsDetail := TDataSource.Create(Self);
  wcTracking := TXDataWebClient.Create(Self);
  wdsTracking := TXDataWebDataSet.Create(Self);
  wdsTrackingAutoNo := TIntegerField.Create(Self);
  wdsTrackingLoadConNo := TIntegerField.Create(Self);
  wdsTrackingForUserCode := TStringField.Create(Self);
  wdsTrackingScanDateTime := TDateTimeField.Create(Self);
  wdsTrackingScanType := TStringField.Create(Self);
  wdsTrackingForUserName := TStringField.Create(Self);
  wdsTrackingScanUser := TStringField.Create(Self);
  wdsTrackingScanName := TStringField.Create(Self);
  dsTracking := TDataSource.Create(Self);

  wpTop.BeforeLoadDFMValues;
  TMSFNCButton1.BeforeLoadDFMValues;
  WebScrollBox1.BeforeLoadDFMValues;
  wpLeft.BeforeLoadDFMValues;
  gClient.BeforeLoadDFMValues;
  gdaClient.BeforeLoadDFMValues;
  wpRight.BeforeLoadDFMValues;
  gDetail.BeforeLoadDFMValues;
  gdaDetail.BeforeLoadDFMValues;
  gTracking.BeforeLoadDFMValues;
  gdaTracking.BeforeLoadDFMValues;
  wcClient.BeforeLoadDFMValues;
  wdsClient.BeforeLoadDFMValues;
  wdsClientDebName.BeforeLoadDFMValues;
  wdsClientContractName.BeforeLoadDFMValues;
  wdsClientDebCode.BeforeLoadDFMValues;
  wdsClientContractNo.BeforeLoadDFMValues;
  wdsClientTotalLoads.BeforeLoadDFMValues;
  wdsClientLess10Days.BeforeLoadDFMValues;
  wdsClientOver10Days.BeforeLoadDFMValues;
  wdsClientOver20Days.BeforeLoadDFMValues;
  dsClient.BeforeLoadDFMValues;
  wcDetail.BeforeLoadDFMValues;
  wdsDetail.BeforeLoadDFMValues;
  wdsDetailLoadConNo.BeforeLoadDFMValues;
  wdsDetailRegNo.BeforeLoadDFMValues;
  wdsDetailController.BeforeLoadDFMValues;
  wdsDetailLoadedDate.BeforeLoadDFMValues;
  wdsDetailReceivedDate.BeforeLoadDFMValues;
  wdsDetailScannedDate.BeforeLoadDFMValues;
  dsDetail.BeforeLoadDFMValues;
  wcTracking.BeforeLoadDFMValues;
  wdsTracking.BeforeLoadDFMValues;
  wdsTrackingAutoNo.BeforeLoadDFMValues;
  wdsTrackingLoadConNo.BeforeLoadDFMValues;
  wdsTrackingForUserCode.BeforeLoadDFMValues;
  wdsTrackingScanDateTime.BeforeLoadDFMValues;
  wdsTrackingScanType.BeforeLoadDFMValues;
  wdsTrackingForUserName.BeforeLoadDFMValues;
  wdsTrackingScanUser.BeforeLoadDFMValues;
  wdsTrackingScanName.BeforeLoadDFMValues;
  dsTracking.BeforeLoadDFMValues;
  try
    Name := 'frmdashboardloadsnotinvoiced';
    Width := 1419;
    Height := 567;
    wpTop.SetParentComponent(Self);
    wpTop.Name := 'wpTop';
    wpTop.Left := 0;
    wpTop.Top := 0;
    wpTop.Width := 1419;
    wpTop.Height := 41;
    wpTop.Align := alTop;
    wpTop.Caption := 'Loads Dashboard Not Invoiced';
    wpTop.Font.Charset := DEFAULT_CHARSET;
    wpTop.Font.Color := clWindowText;
    wpTop.Font.Height := -12;
    wpTop.Font.Name := 'Segoe UI';
    wpTop.Font.Style := [fsBold];
    wpTop.ParentFont := False;
    wpTop.TabOrder := 0;
    TMSFNCButton1.SetParentComponent(wpTop);
    TMSFNCButton1.Name := 'TMSFNCButton1';
    TMSFNCButton1.Left := 19;
    TMSFNCButton1.Top := 8;
    TMSFNCButton1.Width := 100;
    TMSFNCButton1.Height := 25;
    TMSFNCButton1.Font.Charset := DEFAULT_CHARSET;
    TMSFNCButton1.Font.Color := clWindowText;
    TMSFNCButton1.Font.Height := -12;
    TMSFNCButton1.Font.Name := 'Segoe UI';
    TMSFNCButton1.Font.Style := [];
    TMSFNCButton1.Text := 'Back';
    TMSFNCButton1.TabOrder := 0;
    SetEvent(TMSFNCButton1, Self, 'OnClick', 'TMSFNCButton1Click');
    WebScrollBox1.SetParentComponent(Self);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 41;
    WebScrollBox1.Width := 1419;
    WebScrollBox1.Height := 526;
    WebScrollBox1.Align := alClient;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 1;
    wpLeft.SetParentComponent(WebScrollBox1);
    wpLeft.Name := 'wpLeft';
    wpLeft.Left := 0;
    wpLeft.Top := 0;
    wpLeft.Width := 769;
    wpLeft.Height := 526;
    wpLeft.Align := alLeft;
    wpLeft.TabOrder := 0;
    gClient.SetParentComponent(wpLeft);
    gClient.Name := 'gClient';
    gClient.Left := 0;
    gClient.Top := 0;
    gClient.Width := 769;
    gClient.Height := 526;
    gClient.Align := alClient;
    gClient.ParentDoubleBuffered := False;
    gClient.DoubleBuffered := True;
    gClient.TabOrder := 0;
    gClient.ShowAcceleratorChar := False;
    gClient.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    gClient.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    gClient.Header.VisualGrouping.Layout.Font.Height := -12;
    gClient.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    gClient.Header.VisualGrouping.Layout.Font.Style := [];
    gClient.Adapter := gdaClient;
    gClient.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gClient.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    gClient.CellAppearance.FilterMatchLayout.Font.Height := -12;
    gClient.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    gClient.CellAppearance.FilterMatchLayout.Font.Style := [];
    gClient.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gClient.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    gClient.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    gClient.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    gClient.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    gClient.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gClient.CellAppearance.BandLayout.Font.Color := clWindowText;
    gClient.CellAppearance.BandLayout.Font.Height := -12;
    gClient.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    gClient.CellAppearance.BandLayout.Font.Style := [];
    gClient.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gClient.CellAppearance.FixedLayout.Font.Color := clWindowText;
    gClient.CellAppearance.FixedLayout.Font.Height := -12;
    gClient.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    gClient.CellAppearance.FixedLayout.Font.Style := [];
    gClient.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gClient.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    gClient.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    gClient.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gClient.CellAppearance.FixedSelectedLayout.Font.Style := [];
    gClient.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gClient.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    gClient.CellAppearance.FocusedLayout.Font.Height := -12;
    gClient.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    gClient.CellAppearance.FocusedLayout.Font.Style := [];
    gClient.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gClient.CellAppearance.GroupLayout.Font.Color := clWindowText;
    gClient.CellAppearance.GroupLayout.Font.Height := -12;
    gClient.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    gClient.CellAppearance.GroupLayout.Font.Style := [];
    gClient.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gClient.CellAppearance.NormalLayout.Font.Color := clWindowText;
    gClient.CellAppearance.NormalLayout.Font.Height := -12;
    gClient.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    gClient.CellAppearance.NormalLayout.Font.Style := [];
    gClient.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gClient.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    gClient.CellAppearance.SelectedLayout.Font.Height := -12;
    gClient.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    gClient.CellAppearance.SelectedLayout.Font.Style := [];
    gClient.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gClient.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    gClient.CellAppearance.SummaryLayout.Font.Height := -12;
    gClient.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    gClient.CellAppearance.SummaryLayout.Font.Style := [];
    gClient.ColumnCount := 8;
    gClient.Columns.Clear;
    with gClient.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Client Name';
      Width := 250.000000000000000000;
    end;
    with gClient.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Contract';
      Width := 250.000000000000000000;
    end;
    with gClient.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.WordWrapping := True;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Less 10 Days';
      Settings := [gcsAppearance];
      Width := 60.000000000000000000;
    end;
    with gClient.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.WordWrapping := True;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Over 10 Days';
      Settings := [gcsAppearance];
      Width := 60.000000000000000000;
    end;
    with gClient.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.WordWrapping := True;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Over 20 Days';
      Settings := [gcsAppearance];
      Width := 60.000000000000000000;
    end;
    with gClient.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedLayout.TextAlign := gtaTrailing;
      Appearance.FixedLayout.WordWrapping := True;
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.NormalLayout.TextAlign := gtaTrailing;
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Total Loads';
      Settings := [gcsAppearance];
      Width := 60.000000000000000000;
    end;
    with gClient.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Visible := False;
      Width := 0.000000000000000000;
    end;
    with gClient.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Visible := False;
      Width := 0.000000000000000000;
    end;
    gClient.DefaultRowHeight := 35.000000000000000000;
    gClient.Designer := False;
    gClient.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    gClient.FilterAppearance.Font.Color := clWindowText;
    gClient.FilterAppearance.Font.Height := -12;
    gClient.FilterAppearance.Font.Name := 'Segoe UI';
    gClient.FilterAppearance.Font.Style := [];
    gClient.Icons.ExpandIcon.LoadFromFile('dashboard.loads.notinvoiced.wpLeft.gClient.Icons.ExpandIcon.svg');
    gClient.Icons.CollapseIcon.LoadFromFile('dashboard.loads.notinvoiced.wpLeft.gClient.Icons.CollapseIcon.svg');
    gClient.Icons.FilterIcon.LoadFromFile('dashboard.loads.notinvoiced.wpLeft.gClient.Icons.FilterIcon.svg');
    gClient.Icons.FilterActiveIcon.LoadFromFile('dashboard.loads.notinvoiced.wpLeft.gClient.Icons.FilterActiveIcon.svg');
    gClient.Icons.FilterClearIcon.LoadFromFile('dashboard.loads.notinvoiced.wpLeft.gClient.Icons.FilterClearIcon.svg');
    gClient.Icons.FilterTypeIcon.LoadFromFile('dashboard.loads.notinvoiced.wpLeft.gClient.Icons.FilterTypeIcon.svg');
    gClient.Icons.SortAscendingIcon.LoadFromFile('dashboard.loads.notinvoiced.wpLeft.gClient.Icons.SortAscendingIcon.svg');
    gClient.Icons.SortDescendingIcon.LoadFromFile('dashboard.loads.notinvoiced.wpLeft.gClient.Icons.SortDescendingIcon.svg');
    gClient.Icons.CloseIcon.LoadFromFile('dashboard.loads.notinvoiced.wpLeft.gClient.Icons.CloseIcon.svg');
    SetEvent(gClient, Self, 'OnAfterDrawCell', 'gClientAfterDrawCell');
    SetEvent(gClient, Self, 'OnCellClick', 'gClientCellClick');
    gClient.Options.Grouping.AutoSort := False;
    gClient.Options.Grouping.SummaryInHeader := True;
    gClient.Options.Sorting.Enabled := True;
    gClient.Options.Editing.Enabled := False;
    gClient.RowCount := 1;
    gdaClient.SetParentComponent(gClient);
    gdaClient.Name := 'gdaClient';
    gdaClient.Left := 288;
    gdaClient.Top := 128;
    gdaClient.Width := 26;
    gdaClient.Height := 26;
    gdaClient.Visible := True;
    gdaClient.AutoCreateColumns := False;
    gdaClient.AutoRemoveColumns := False;
    gdaClient.Columns.Clear;
    with gdaClient.Columns.Add do
    begin
      FieldName := 'DebName';
      Header := 'Client Name';
      AutoCreated := False;
    end;
    with gdaClient.Columns.Add do
    begin
      FieldName := 'ContractName';
      Header := 'Contract';
      AutoCreated := False;
    end;
    with gdaClient.Columns.Add do
    begin
      FieldName := 'Less10Days';
      Header := 'Less 10 Days';
      AutoCreated := False;
    end;
    with gdaClient.Columns.Add do
    begin
      FieldName := 'Over10Days';
      Header := 'Over 10 Days';
      AutoCreated := False;
    end;
    with gdaClient.Columns.Add do
    begin
      FieldName := 'Over20Days';
      Header := 'Over 20 Days';
      AutoCreated := False;
    end;
    with gdaClient.Columns.Add do
    begin
      FieldName := 'TotalLoads';
      Header := 'Total Loads';
      AutoCreated := False;
    end;
    with gdaClient.Columns.Add do
    begin
      FieldName := 'DebCode';
      AutoCreated := False;
    end;
    with gdaClient.Columns.Add do
    begin
      FieldName := 'ContractNo';
      AutoCreated := False;
    end;
    gdaClient.DataSource := dsClient;
    gdaClient.LoadMode := almAllRecords;
    wpRight.SetParentComponent(WebScrollBox1);
    wpRight.Name := 'wpRight';
    wpRight.Left := 769;
    wpRight.Top := 0;
    wpRight.Width := 650;
    wpRight.Height := 526;
    wpRight.Align := alClient;
    wpRight.ChildOrder := 1;
    wpRight.TabOrder := 1;
    gDetail.SetParentComponent(wpRight);
    gDetail.Name := 'gDetail';
    gDetail.Left := 0;
    gDetail.Top := 0;
    gDetail.Width := 650;
    gDetail.Height := 297;
    gDetail.Align := alTop;
    gDetail.ParentDoubleBuffered := False;
    gDetail.Anchors := [akLeft,akTop,akRight,akBottom];
    gDetail.DoubleBuffered := True;
    gDetail.TabOrder := 0;
    gDetail.ShowAcceleratorChar := False;
    gDetail.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    gDetail.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    gDetail.Header.VisualGrouping.Layout.Font.Height := -12;
    gDetail.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    gDetail.Header.VisualGrouping.Layout.Font.Style := [];
    gDetail.Adapter := gdaDetail;
    gDetail.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gDetail.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    gDetail.CellAppearance.FilterMatchLayout.Font.Height := -12;
    gDetail.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    gDetail.CellAppearance.FilterMatchLayout.Font.Style := [];
    gDetail.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gDetail.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    gDetail.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    gDetail.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    gDetail.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    gDetail.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gDetail.CellAppearance.BandLayout.Font.Color := clWindowText;
    gDetail.CellAppearance.BandLayout.Font.Height := -12;
    gDetail.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    gDetail.CellAppearance.BandLayout.Font.Style := [];
    gDetail.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gDetail.CellAppearance.FixedLayout.Font.Color := clWindowText;
    gDetail.CellAppearance.FixedLayout.Font.Height := -12;
    gDetail.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    gDetail.CellAppearance.FixedLayout.Font.Style := [];
    gDetail.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gDetail.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    gDetail.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    gDetail.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gDetail.CellAppearance.FixedSelectedLayout.Font.Style := [];
    gDetail.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gDetail.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    gDetail.CellAppearance.FocusedLayout.Font.Height := -12;
    gDetail.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    gDetail.CellAppearance.FocusedLayout.Font.Style := [];
    gDetail.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gDetail.CellAppearance.GroupLayout.Font.Color := clWindowText;
    gDetail.CellAppearance.GroupLayout.Font.Height := -12;
    gDetail.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    gDetail.CellAppearance.GroupLayout.Font.Style := [];
    gDetail.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gDetail.CellAppearance.NormalLayout.Font.Color := clWindowText;
    gDetail.CellAppearance.NormalLayout.Font.Height := -12;
    gDetail.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    gDetail.CellAppearance.NormalLayout.Font.Style := [];
    gDetail.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gDetail.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    gDetail.CellAppearance.SelectedLayout.Font.Height := -12;
    gDetail.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    gDetail.CellAppearance.SelectedLayout.Font.Style := [];
    gDetail.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gDetail.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    gDetail.CellAppearance.SummaryLayout.Font.Height := -12;
    gDetail.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    gDetail.CellAppearance.SummaryLayout.Font.Style := [];
    gDetail.ColumnCount := 6;
    gDetail.Columns.Clear;
    with gDetail.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Loadcon No';
      Settings := [gcsReadOnly];
      Width := 95.000000000000000000;
    end;
    with gDetail.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Loaded Date';
      Settings := [gcsReadOnly];
      Width := 95.000000000000000000;
    end;
    with gDetail.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Received Date';
      Settings := [gcsReadOnly];
      Width := 95.000000000000000000;
    end;
    with gDetail.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Scanned Date';
      Settings := [gcsReadOnly];
      Width := 95.000000000000000000;
    end;
    with gDetail.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Reg No';
      Settings := [gcsReadOnly];
      Width := 110.000000000000000000;
    end;
    with gDetail.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Controller';
      Settings := [gcsReadOnly];
      Width := 120.000000000000000000;
    end;
    gDetail.Designer := False;
    gDetail.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    gDetail.FilterAppearance.Font.Color := clWindowText;
    gDetail.FilterAppearance.Font.Height := -12;
    gDetail.FilterAppearance.Font.Name := 'Segoe UI';
    gDetail.FilterAppearance.Font.Style := [];
    gDetail.Icons.ExpandIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gDetail.Icons.ExpandIcon.svg');
    gDetail.Icons.CollapseIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gDetail.Icons.CollapseIcon.svg');
    gDetail.Icons.FilterIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gDetail.Icons.FilterIcon.svg');
    gDetail.Icons.FilterActiveIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gDetail.Icons.FilterActiveIcon.svg');
    gDetail.Icons.FilterClearIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gDetail.Icons.FilterClearIcon.svg');
    gDetail.Icons.FilterTypeIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gDetail.Icons.FilterTypeIcon.svg');
    gDetail.Icons.SortAscendingIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gDetail.Icons.SortAscendingIcon.svg');
    gDetail.Icons.SortDescendingIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gDetail.Icons.SortDescendingIcon.svg');
    gDetail.Icons.CloseIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gDetail.Icons.CloseIcon.svg');
    SetEvent(gDetail, Self, 'OnAfterDrawCell', 'gDetailAfterDrawCell');
    SetEvent(gDetail, Self, 'OnCellClick', 'gDetailCellClick');
    SetEvent(gDetail, Self, 'OnGetCellFormatting', 'gDetailGetCellFormatting');
    gDetail.Options.Sorting.Enabled := True;
    gDetail.RowCount := 1;
    gdaDetail.SetParentComponent(gDetail);
    gdaDetail.Name := 'gdaDetail';
    gdaDetail.Left := 136;
    gdaDetail.Top := 96;
    gdaDetail.Width := 26;
    gdaDetail.Height := 26;
    gdaDetail.Visible := True;
    gdaDetail.AutoCreateColumns := False;
    gdaDetail.AutoRemoveColumns := False;
    gdaDetail.Columns.Clear;
    with gdaDetail.Columns.Add do
    begin
      FieldName := 'LoadConNo';
      Header := 'Loadcon No';
      AutoCreated := False;
    end;
    with gdaDetail.Columns.Add do
    begin
      FieldName := 'LoadedDate';
      Header := 'Loaded Date';
      AutoCreated := False;
    end;
    with gdaDetail.Columns.Add do
    begin
      FieldName := 'ReceivedDate';
      Header := 'Received Date';
      AutoCreated := False;
    end;
    with gdaDetail.Columns.Add do
    begin
      FieldName := 'ScannedDate';
      Header := 'Scanned Date';
      AutoCreated := False;
    end;
    with gdaDetail.Columns.Add do
    begin
      FieldName := 'RegNo';
      Header := 'Reg No';
      AutoCreated := False;
    end;
    with gdaDetail.Columns.Add do
    begin
      FieldName := 'Controller';
      Header := 'Controller';
      AutoCreated := False;
    end;
    gdaDetail.DataSource := dsDetail;
    gdaDetail.LoadMode := almAllRecords;
    gTracking.SetParentComponent(wpRight);
    gTracking.Name := 'gTracking';
    gTracking.Left := 0;
    gTracking.Top := 297;
    gTracking.Width := 650;
    gTracking.Height := 229;
    gTracking.Align := alClient;
    gTracking.ParentDoubleBuffered := False;
    gTracking.DoubleBuffered := True;
    gTracking.TabOrder := 1;
    gTracking.ShowAcceleratorChar := False;
    gTracking.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    gTracking.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    gTracking.Header.VisualGrouping.Layout.Font.Height := -12;
    gTracking.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    gTracking.Header.VisualGrouping.Layout.Font.Style := [];
    gTracking.Adapter := gdaTracking;
    gTracking.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gTracking.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    gTracking.CellAppearance.FilterMatchLayout.Font.Height := -12;
    gTracking.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    gTracking.CellAppearance.FilterMatchLayout.Font.Style := [];
    gTracking.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gTracking.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    gTracking.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    gTracking.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    gTracking.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    gTracking.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gTracking.CellAppearance.BandLayout.Font.Color := clWindowText;
    gTracking.CellAppearance.BandLayout.Font.Height := -12;
    gTracking.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    gTracking.CellAppearance.BandLayout.Font.Style := [];
    gTracking.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gTracking.CellAppearance.FixedLayout.Font.Color := clWindowText;
    gTracking.CellAppearance.FixedLayout.Font.Height := -12;
    gTracking.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    gTracking.CellAppearance.FixedLayout.Font.Style := [];
    gTracking.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gTracking.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    gTracking.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    gTracking.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gTracking.CellAppearance.FixedSelectedLayout.Font.Style := [];
    gTracking.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gTracking.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    gTracking.CellAppearance.FocusedLayout.Font.Height := -12;
    gTracking.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    gTracking.CellAppearance.FocusedLayout.Font.Style := [];
    gTracking.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gTracking.CellAppearance.GroupLayout.Font.Color := clWindowText;
    gTracking.CellAppearance.GroupLayout.Font.Height := -12;
    gTracking.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    gTracking.CellAppearance.GroupLayout.Font.Style := [];
    gTracking.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gTracking.CellAppearance.NormalLayout.Font.Color := clWindowText;
    gTracking.CellAppearance.NormalLayout.Font.Height := -12;
    gTracking.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    gTracking.CellAppearance.NormalLayout.Font.Style := [];
    gTracking.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gTracking.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    gTracking.CellAppearance.SelectedLayout.Font.Height := -12;
    gTracking.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    gTracking.CellAppearance.SelectedLayout.Font.Style := [];
    gTracking.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gTracking.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    gTracking.CellAppearance.SummaryLayout.Font.Height := -12;
    gTracking.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    gTracking.CellAppearance.SummaryLayout.Font.Style := [];
    gTracking.Columns.Clear;
    with gTracking.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Scan Date';
      Settings := [gcsReadOnly];
      Width := 95.000000000000000000;
    end;
    with gTracking.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Type';
      Settings := [gcsReadOnly];
      Width := 95.000000000000000000;
    end;
    with gTracking.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Scan User';
      Settings := [gcsReadOnly];
      Width := 150.000000000000000000;
    end;
    with gTracking.Columns.Add do
    begin
      ReadOnly := True;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Scan For User';
      Settings := [gcsReadOnly];
      Width := 150.000000000000000000;
    end;
    gTracking.Designer := False;
    gTracking.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    gTracking.FilterAppearance.Font.Color := clWindowText;
    gTracking.FilterAppearance.Font.Height := -12;
    gTracking.FilterAppearance.Font.Name := 'Segoe UI';
    gTracking.FilterAppearance.Font.Style := [];
    gTracking.Icons.ExpandIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gTracking.Icons.ExpandIcon.svg');
    gTracking.Icons.CollapseIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gTracking.Icons.CollapseIcon.svg');
    gTracking.Icons.FilterIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gTracking.Icons.FilterIcon.svg');
    gTracking.Icons.FilterActiveIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gTracking.Icons.FilterActiveIcon.svg');
    gTracking.Icons.FilterClearIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gTracking.Icons.FilterClearIcon.svg');
    gTracking.Icons.FilterTypeIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gTracking.Icons.FilterTypeIcon.svg');
    gTracking.Icons.SortAscendingIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gTracking.Icons.SortAscendingIcon.svg');
    gTracking.Icons.SortDescendingIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gTracking.Icons.SortDescendingIcon.svg');
    gTracking.Icons.CloseIcon.LoadFromFile('dashboard.loads.notinvoiced.wpRight.gTracking.Icons.CloseIcon.svg');
    SetEvent(gTracking, Self, 'OnAfterDrawCell', 'gTrackingAfterDrawCell');
    SetEvent(gTracking, Self, 'OnGetCellFormatting', 'gTrackingGetCellFormatting');
    gTracking.Options.Sorting.Enabled := True;
    gTracking.RowCount := 1;
    gdaTracking.SetParentComponent(gTracking);
    gdaTracking.Name := 'gdaTracking';
    gdaTracking.Left := 160;
    gdaTracking.Top := 96;
    gdaTracking.Width := 26;
    gdaTracking.Height := 26;
    gdaTracking.Visible := True;
    gdaTracking.AutoCreateColumns := False;
    gdaTracking.AutoRemoveColumns := False;
    gdaTracking.Columns.Clear;
    with gdaTracking.Columns.Add do
    begin
      FieldName := 'ScanDateTime';
      Header := 'Scan Date';
      AutoCreated := False;
    end;
    with gdaTracking.Columns.Add do
    begin
      FieldName := 'ScanType';
      Header := 'Type';
      AutoCreated := False;
    end;
    with gdaTracking.Columns.Add do
    begin
      FieldName := 'ScanName';
      Header := 'Scan User';
      AutoCreated := False;
    end;
    with gdaTracking.Columns.Add do
    begin
      FieldName := 'ForUserName';
      Header := 'Scan For User';
      AutoCreated := False;
    end;
    gdaTracking.DataSource := dsTracking;
    gdaTracking.LoadMode := almAllRecords;
    wcClient.SetParentComponent(Self);
    wcClient.Name := 'wcClient';
    wcClient.Connection := dmData.dbConnect;
    wcClient.Left := 160;
    wcClient.Top := 81;
    wdsClient.SetParentComponent(Self);
    wdsClient.Name := 'wdsClient';
    wdsClient.AfterOpen := wdsClientAfterOpen;
    wdsClient.Connection := dmData.dbConnect;
    wdsClient.Left := 192;
    wdsClient.Top := 145;
    wdsClientDebName.SetParentComponent(wdsClient);
    wdsClientDebName.Name := 'wdsClientDebName';
    wdsClientDebName.FieldName := 'DebName';
    wdsClientContractName.SetParentComponent(wdsClient);
    wdsClientContractName.Name := 'wdsClientContractName';
    wdsClientContractName.FieldName := 'ContractName';
    wdsClientDebCode.SetParentComponent(wdsClient);
    wdsClientDebCode.Name := 'wdsClientDebCode';
    wdsClientDebCode.FieldName := 'DebCode';
    wdsClientContractNo.SetParentComponent(wdsClient);
    wdsClientContractNo.Name := 'wdsClientContractNo';
    wdsClientContractNo.FieldName := 'ContractNo';
    wdsClientTotalLoads.SetParentComponent(wdsClient);
    wdsClientTotalLoads.Name := 'wdsClientTotalLoads';
    wdsClientTotalLoads.FieldName := 'TotalLoads';
    wdsClientLess10Days.SetParentComponent(wdsClient);
    wdsClientLess10Days.Name := 'wdsClientLess10Days';
    wdsClientLess10Days.FieldName := 'Less10Days';
    wdsClientOver10Days.SetParentComponent(wdsClient);
    wdsClientOver10Days.Name := 'wdsClientOver10Days';
    wdsClientOver10Days.FieldName := 'Over10Days';
    wdsClientOver20Days.SetParentComponent(wdsClient);
    wdsClientOver20Days.Name := 'wdsClientOver20Days';
    wdsClientOver20Days.FieldName := 'Over20Days';
    dsClient.SetParentComponent(Self);
    dsClient.Name := 'dsClient';
    dsClient.AutoEdit := False;
    dsClient.DataSet := wdsClient;
    dsClient.Left := 240;
    dsClient.Top := 81;
    wcDetail.SetParentComponent(Self);
    wcDetail.Name := 'wcDetail';
    wcDetail.Connection := dmData.dbConnect;
    wcDetail.Left := 817;
    wcDetail.Top := 153;
    wdsDetail.SetParentComponent(Self);
    wdsDetail.Name := 'wdsDetail';
    wdsDetail.Connection := dmData.dbConnect;
    wdsDetail.Left := 961;
    wdsDetail.Top := 153;
    wdsDetailLoadConNo.SetParentComponent(wdsDetail);
    wdsDetailLoadConNo.Name := 'wdsDetailLoadConNo';
    wdsDetailLoadConNo.FieldName := 'LoadConNo';
    wdsDetailRegNo.SetParentComponent(wdsDetail);
    wdsDetailRegNo.Name := 'wdsDetailRegNo';
    wdsDetailRegNo.FieldName := 'RegNo';
    wdsDetailController.SetParentComponent(wdsDetail);
    wdsDetailController.Name := 'wdsDetailController';
    wdsDetailController.FieldName := 'Controller';
    wdsDetailLoadedDate.SetParentComponent(wdsDetail);
    wdsDetailLoadedDate.Name := 'wdsDetailLoadedDate';
    wdsDetailLoadedDate.FieldName := 'LoadedDate';
    wdsDetailReceivedDate.SetParentComponent(wdsDetail);
    wdsDetailReceivedDate.Name := 'wdsDetailReceivedDate';
    wdsDetailReceivedDate.FieldName := 'ReceivedDate';
    wdsDetailScannedDate.SetParentComponent(wdsDetail);
    wdsDetailScannedDate.Name := 'wdsDetailScannedDate';
    wdsDetailScannedDate.FieldName := 'ScannedDate';
    dsDetail.SetParentComponent(Self);
    dsDetail.Name := 'dsDetail';
    dsDetail.AutoEdit := False;
    dsDetail.DataSet := wdsDetail;
    dsDetail.Left := 1025;
    dsDetail.Top := 153;
    wcTracking.SetParentComponent(Self);
    wcTracking.Name := 'wcTracking';
    wcTracking.Connection := dmData.dbConnect;
    wcTracking.Left := 841;
    wcTracking.Top := 362;
    wdsTracking.SetParentComponent(Self);
    wdsTracking.Name := 'wdsTracking';
    wdsTracking.Connection := dmData.dbConnect;
    wdsTracking.Left := 857;
    wdsTracking.Top := 426;
    wdsTrackingAutoNo.SetParentComponent(wdsTracking);
    wdsTrackingAutoNo.Name := 'wdsTrackingAutoNo';
    wdsTrackingAutoNo.FieldName := 'AutoNo';
    wdsTrackingLoadConNo.SetParentComponent(wdsTracking);
    wdsTrackingLoadConNo.Name := 'wdsTrackingLoadConNo';
    wdsTrackingLoadConNo.FieldName := 'LoadConNo';
    wdsTrackingForUserCode.SetParentComponent(wdsTracking);
    wdsTrackingForUserCode.Name := 'wdsTrackingForUserCode';
    wdsTrackingForUserCode.FieldName := 'ForUserCode';
    wdsTrackingScanDateTime.SetParentComponent(wdsTracking);
    wdsTrackingScanDateTime.Name := 'wdsTrackingScanDateTime';
    wdsTrackingScanDateTime.FieldName := 'ScanDateTime';
    wdsTrackingScanType.SetParentComponent(wdsTracking);
    wdsTrackingScanType.Name := 'wdsTrackingScanType';
    wdsTrackingScanType.FieldName := 'ScanType';
    wdsTrackingForUserName.SetParentComponent(wdsTracking);
    wdsTrackingForUserName.Name := 'wdsTrackingForUserName';
    wdsTrackingForUserName.FieldName := 'ForUserName';
    wdsTrackingScanUser.SetParentComponent(wdsTracking);
    wdsTrackingScanUser.Name := 'wdsTrackingScanUser';
    wdsTrackingScanUser.FieldName := 'ScanUser';
    wdsTrackingScanName.SetParentComponent(wdsTracking);
    wdsTrackingScanName.Name := 'wdsTrackingScanName';
    wdsTrackingScanName.FieldName := 'ScanName';
    dsTracking.SetParentComponent(Self);
    dsTracking.Name := 'dsTracking';
    dsTracking.AutoEdit := False;
    dsTracking.DataSet := wdsTracking;
    dsTracking.Left := 969;
    dsTracking.Top := 378;
  finally
    wpTop.AfterLoadDFMValues;
    TMSFNCButton1.AfterLoadDFMValues;
    WebScrollBox1.AfterLoadDFMValues;
    wpLeft.AfterLoadDFMValues;
    gClient.AfterLoadDFMValues;
    gdaClient.AfterLoadDFMValues;
    wpRight.AfterLoadDFMValues;
    gDetail.AfterLoadDFMValues;
    gdaDetail.AfterLoadDFMValues;
    gTracking.AfterLoadDFMValues;
    gdaTracking.AfterLoadDFMValues;
    wcClient.AfterLoadDFMValues;
    wdsClient.AfterLoadDFMValues;
    wdsClientDebName.AfterLoadDFMValues;
    wdsClientContractName.AfterLoadDFMValues;
    wdsClientDebCode.AfterLoadDFMValues;
    wdsClientContractNo.AfterLoadDFMValues;
    wdsClientTotalLoads.AfterLoadDFMValues;
    wdsClientLess10Days.AfterLoadDFMValues;
    wdsClientOver10Days.AfterLoadDFMValues;
    wdsClientOver20Days.AfterLoadDFMValues;
    dsClient.AfterLoadDFMValues;
    wcDetail.AfterLoadDFMValues;
    wdsDetail.AfterLoadDFMValues;
    wdsDetailLoadConNo.AfterLoadDFMValues;
    wdsDetailRegNo.AfterLoadDFMValues;
    wdsDetailController.AfterLoadDFMValues;
    wdsDetailLoadedDate.AfterLoadDFMValues;
    wdsDetailReceivedDate.AfterLoadDFMValues;
    wdsDetailScannedDate.AfterLoadDFMValues;
    dsDetail.AfterLoadDFMValues;
    wcTracking.AfterLoadDFMValues;
    wdsTracking.AfterLoadDFMValues;
    wdsTrackingAutoNo.AfterLoadDFMValues;
    wdsTrackingLoadConNo.AfterLoadDFMValues;
    wdsTrackingForUserCode.AfterLoadDFMValues;
    wdsTrackingScanDateTime.AfterLoadDFMValues;
    wdsTrackingScanType.AfterLoadDFMValues;
    wdsTrackingForUserName.AfterLoadDFMValues;
    wdsTrackingScanUser.AfterLoadDFMValues;
    wdsTrackingScanName.AfterLoadDFMValues;
    dsTracking.AfterLoadDFMValues;
  end;
end;

end.
